/**
 * Aba Auto-close em edição (PR4). Edita `autoCloseable` (liga/desliga) e
 * `autoCloseableOutcomes` (resultados permitidos). O `outcomeReasonCatalog`
 * segue READ-ONLY (estrutura aninhada Record<outcome, razões[]> — edição fora do
 * escopo do PR4). KPIs de uso do mockup não têm fonte → omitidos.
 */

import { autoCloseOutcomeLabel } from '../playbook-labels';

import { ChipListEditor } from './ChipListEditor';


import type { PlaybookDto } from '../types';
import type { PlaybookForm } from '../use-playbook-form';

export function TabAutoCloseEdit({
  form,
  playbook,
}: {
  form: PlaybookForm;
  playbook: PlaybookDto;
}): JSX.Element {
  const { draft, set } = form;
  const catalogEntries =
    playbook.outcomeReasonCatalog !== null ? Object.entries(playbook.outcomeReasonCatalog) : [];

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Auto-close">
      <h2 className="pb-panel__title">Auto-close</h2>

      <div className="pb-panel__section">
        <span className="pb-panel__section-label">Fechamento automático pela IA</span>
        <button
          type="button"
          className={'pb-check' + (draft.autoCloseable ? ' pb-check--checked' : '')}
          role="switch"
          aria-checked={draft.autoCloseable}
          onClick={() => {
            set('autoCloseable', !draft.autoCloseable);
          }}
        >
          <span className="pb-check__box" />
          <span className="pb-check__main">
            <span className="pb-check__label">
              Permitir que a IA encerre conversas deste playbook
            </span>
            <span className="pb-check__desc">
              {draft.autoCloseable
                ? 'A IA pode encerrar conversas quando o resultado é permitido.'
                : 'A IA não encerra conversas deste playbook automaticamente.'}
            </span>
          </span>
        </button>
      </div>

      {draft.autoCloseable && (
        <>
          <div className="pb-panel__divider" />
          <div className="pb-panel__section">
            <span className="pb-panel__section-label">Resultados permitidos para auto-close</span>
            <ChipListEditor
              values={draft.autoCloseableOutcomes}
              onChange={(next) => {
                set('autoCloseableOutcomes', next);
              }}
              placeholder="ex.: service-completed"
              mono
              ariaLabel="Adicionar resultado permitido"
            />
          </div>
        </>
      )}

      <div className="pb-panel__divider" />

      <div className="pb-panel__section">
        <span className="pb-panel__section-label">Catálogo de razões por resultado (leitura)</span>
        {catalogEntries.length > 0 ? (
          <div className="pb-catalog">
            {catalogEntries.map(([outcome, reasons]) => (
              <div key={outcome} className="pb-catalog__group">
                <span className="pb-catalog__outcome" title={outcome}>
                  {autoCloseOutcomeLabel(outcome)}
                </span>
                <div className="pb-chip-row">
                  {reasons.map((reason) => (
                    <span key={reason} className="pb-chip pb-chip--mono">
                      {reason}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="pb-read-value pb-read-value--muted">Nenhum catálogo de razões definido</p>
        )}
      </div>
    </div>
  );
}
